import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'Salatu orri hau',
  title: 'Salatu orri honetako arazo bat',
  reasons: {
    'inaccurate-or-fabricated': 'Informazio okerra edo asmatua',
    'wrong-product': 'Produktuak ez datoz bat orriarekin',
    'sexually-explicit': 'Eduki sexual esplizitua',
    'regulated-product': 'Errezeta behar duen edo araututako produktua',
    'dangerous-product': 'Produktu arriskutsua',
    'ip-infringement': 'Nire eskubideak urratzen ditu (marka/egile-eskubideak)',
    other: 'Beste zerbait',
  },
  detail: 'Xehetasunak (aukerakoa)',
  submit: 'Bidali salaketa',
  cancel: 'Utzi',
  sent: 'Eskerrik asko. Salaketak 24 orduko epean berrikusten ditugu.',
  failed: 'Ezin izan da salaketa bidali. Saiatu berriro, mesedez.',
};
